module.exports = __webpack_public_path__ + "img/Newbie_Sword_03_Classic.5db9f654.png";